import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter. Must be equal to the column field.
 */
export const FILTER_KEY = 'supportsKep' as const;

/**
 * The options of the filter.
 */
export const OPTIONS = [
  { value: '1', label: 'Áno' },
  { value: '0', label: 'Nie' },
];

/**
 * Parameters of the SupportsKepSelectFilter component.
 */
export interface SupportsKepSelectFilterProps {
  api: GridApi;
  onChange: FilterChangeCallback;
}

/**
 * Filter component for the supportsKep column.
 *
 * This filter assumes:
 * - column field is `supportsKep`
 */
export default function SupportsKepSelectFilter({ api, onChange }: SupportsKepSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange });

  return (
    <Select
      searchable
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky"
      data={OPTIONS}
      value={value}
      onChange={setValue}
    />
  );
}
